
import { mixin } from "@cems-eco/core/src/utils/platform";
import environment from "@/config";

import BoxTableComponent from "./table.box";
import CloudTableComponent from "./table.cloud";
import DemoTableComponent from "./table.demo";

export default class Web extends mixin(environment.nexus, {
  box: BoxTableComponent,
  cloud: CloudTableComponent,
  demo: DemoTableComponent,
}) { }
